<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header">
				<s-header></s-header>
			</el-header>
			<el-main>				
				<div style="display: flex;flex-direction: column;width: 500px;margin: 100px auto 0px;background: #fff;padding: 50px 50px 50px 50px;">
					<div style="line-height: 60px;text-align: center;">用户注册</div>
					<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px">
					  <el-form-item label="手机号码" prop="telephone">
						<el-input type="telephone" v-model="ruleForm.telephone" autocomplete="off"></el-input>
					  </el-form-item>
					  <el-form-item label="密码" prop="password">
						<el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input>
					  </el-form-item>
					  <el-form-item label="确认密码" prop="checkpassword">
						<el-input type="checkpassword" v-model="ruleForm.checkpassword" autocomplete="off"></el-input>
					  </el-form-item>
					  <div style="text-align: center;">
						<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
					  </div>
					</el-form>
				</div>
			</el-main>
			<el-footer class="footer">
				<s-footer></s-footer>
			</el-footer>
			<el-footer class="copy-right">
				<s-copyRight></s-copyRight>
			</el-footer>
		</el-scrollbar>
	</el-container>	
</template>

<script>
import sHeader from '@/components/header'
import sFooter from '@/components/footer'
import sCopyRight from '@/components/copy-right'
import { register } from '@/api';
export default {
	name: 'register',
	components:{
		sHeader,
		sFooter,
		sCopyRight
	},
	data () {		
		var validateTel = (rule, value, callback) => {
			if (!value) {
			  return callback(new Error('手机号不能为空'));
			} else  if (!/^1(3|4|5|6|7|8)\d{9}$/.test(value)) {
				return callback(new Error('请输入正确的手机号'));
			} else {
				callback();
			}
		};
		var validatePass = (rule, value, callback) => {
			if (value === '') {
			  callback(new Error('请输入密码'));
			} else {
			  if (this.ruleForm.checkPass !== '') {
				this.$refs.ruleForm.validateField('checkPass');
			  }
			  callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
			  callback(new Error('请再次输入密码'));
			} else if (value !== this.ruleForm.password) {
			  callback(new Error('两次输入密码不一致!'));
			} else {
			  callback();
			}
		};
		return {
			ruleForm:{
				telephone: '',
				password: '',
				checkpassword: ''
			},
			rules: {
				telephone: [
					{ validator: validateTel, trigger: 'blur' }
				],
				password: [
					{ validator: validatePass, trigger: 'blur' }
				],
				checkpassword: [
					{ validator: validatePass2, trigger: 'blur' }
				],			 
			}
		}
	},
	methods: {
		submitForm(formName) {
			let that = this
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				register(that.ruleForm).then(res=> {
					// 执行某些操作 
					this.$router.push({path:'/index'})
				})
			  } else {
				return false;
			  }
			});
		},
		goIndex(){
			this.$router.push({path:'/index'})
		}
	}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/register.vue